/**
 * The type of (redux) action which signals that a virtual key was pressed
 *
 * {
 *     type: VIRTUAL_KEY_PRESSED,
 *     keyValue: String,
 * }
 */
export const VIRTUAL_KEY_PRESSED = 'VIRTUAL_KEY_PRESSED';

/**
 * The type of (redux) action which signals that a physical key was pressed
 *
 * {
 *     type: PHYSICAL_KEY_PRESSED,
 *     keyboardEvent: Object,
 * }
 */
export const PHYSICAL_KEY_PRESSED = 'PHYSICAL_KEY_PRESSED';

/**
 * The type of (redux) action which signals that a password in dialog was entered
 *
 * {
 *     type: ON_PASSWORD_CHANGED,
 *     password: String,
 * }
 */
export const ON_PASSWORD_CHANGED = 'ON_PASSWORD_CHANGED';

/**
 * The type of (redux) action which signals that a virtual enter was pressed
 *
 * {
 *     type: SUBMIT_VIRTUAL_PASSWORD,
 *     payload: Boolean,
 * }
 */
export const SUBMIT_VIRTUAL_PASSWORD = 'SUBMIT_VIRTUAL_PASSWORD';

/**
 * The type of (redux) action which signals that a pin correct or not
 *
 * {
 *     type: VALIDATE_PIN,
 *     pinData: String,
 * }
 */
export const VALIDATE_PIN = 'VALIDATE_PIN';
